import { TucanoAdminUI } from "../../types";
import { MediaDTO, MediaDTOList, MediaParams } from "../../openapi/studio-api";
import { TauiServices } from "../../types/structure";

export const studioListMedias = async (taui: TucanoAdminUI, assetId: string) =>
  taui.callApi<MediaDTOList>(
    "GET",
    TauiServices.studio,
    `/asset/${assetId}/media`,
    "studio.catalog.read"
  );

export const studioGetMedia = async (
  taui: TucanoAdminUI,
  assetId: string,
  mediaId: string
) =>
  taui.callApi<MediaDTO>(
    "GET",
    TauiServices.studio,
    `/asset/${assetId}/media/${mediaId}`,
    "studio.catalog.read"
  );

export const studioCreateMedia = async (
  taui: TucanoAdminUI,
  assetId: string,
  params: MediaParams
) =>
  taui.callApi<MediaDTO>(
    "POST",
    TauiServices.studio,
    `/asset/${assetId}/media`,
    "studio.catalog.update",
    params
  );

export const studioUpdateMedia = async (
  taui: TucanoAdminUI,
  assetId: string,
  mediaId: string,
  params: MediaParams
) =>
  taui.callApi<MediaDTO>(
    "PUT",
    TauiServices.studio,
    `/asset/${assetId}/media/${mediaId}`,
    "studio.catalog.update",
    params
  );

export const studioDeleteMedia = async (
  taui: TucanoAdminUI,
  assetId: string,
  mediaId: string
) =>
  taui.callApi<void>(
    "DELETE",
    TauiServices.studio,
    `/asset/${assetId}/media/${mediaId}`,
    "studio.catalog.delete"
  );
